import { IAuthEvent } from '@features/auth/core/domain/events/auth.event';
import { SESSION_STORAGE_KEYS } from '../../const';
import { LocalStorageConfigKeys } from '@config/app-storage/local-storage.config';
import { environment } from '@config/environments/environment';

export class StorageHelper {
  public static STORAGE_KEY = SESSION_STORAGE_KEYS;

  public static storeCallbackURL(redirect: string) {
    // Case: '/feature/dashboard' -> 'feature/dashboard'
    if (redirect.startsWith('/')) {
      redirect = redirect.substring(1);
    }
    sessionStorage.setItem(StorageHelper.STORAGE_KEY.CALLBACK_URL, redirect);
  }

  public static getCallBackURL() {
    return sessionStorage.getItem(StorageHelper.STORAGE_KEY.CALLBACK_URL) ?? '';
  }

  public static storeAuthRequire(req: any | undefined) {
    sessionStorage.setItem(
      StorageHelper.STORAGE_KEY.CURRENT_REQUIREMENT_AFTER_LOGIN,
      req ? JSON.stringify(req) : ''
    );
  }

  public static getAuthRequire() {
    return (
      sessionStorage.getItem(
        StorageHelper.STORAGE_KEY.CURRENT_REQUIREMENT_AFTER_LOGIN
      ) ?? ''
    );
  }

  public static storeLoginCountError(count: number) {
    sessionStorage.setItem(
      StorageHelper.STORAGE_KEY.LOGIN_ERROR_RECAPTCHA_COUNT,
      count.toString()
    );
  }
  public static getLoginCountError() {
    return (
      sessionStorage.getItem(
        StorageHelper.STORAGE_KEY.LOGIN_ERROR_RECAPTCHA_COUNT
      ) ?? 0
    );
  }

  public static setAuthInfo(
    token: string,
    authInfo: any | undefined,
    activatedAction: string[] | number[]
  ) {
    localStorage.setItem(StorageHelper.STORAGE_KEY.ACCESS_TOKEN, token);
    localStorage.setItem(
      StorageHelper.STORAGE_KEY.USER_INFORMATION,
      JSON.stringify(authInfo)
    );
    localStorage.setItem(
      StorageHelper.STORAGE_KEY.LIST_ACTION_ACTIVE,
      JSON.stringify(StorageHelper.chonMaQuyen(activatedAction))
    );
  }

  /**
   * Mã quyền thật ghi vào storage — trừ khi env khai `authMenuOverride` (chỉ local/test).
   *
   * Đặt ở đây vì `setAuthInfo` là chỗ DUY NHẤT ghi `LIST_ACTION_ACTIVE` — mọi luồng
   * đăng nhập (v1, v2, token, bên thứ ba) đều đi qua, không sót nhánh nào.
   * `environment.prod.ts` để mảng rỗng nên bản chính thức luôn dùng quyền máy chủ.
   */
  private static chonMaQuyen(maTuMayChu: string[] | number[]): string[] | number[] {
    const ghiDe = environment.authMenuOverride;
    if (Array.isArray(ghiDe) && ghiDe.length > 0) {
      console.warn(
        `[StorageHelper] GHI ĐÈ mã quyền bằng environment.authMenuOverride (${ghiDe.length} mã) — chỉ được có ở local/test.`
      );
      return ghiDe;
    }
    return maTuMayChu;
  }

  public static emptySessionAndLocalStorage() {
    localStorage.removeItem(StorageHelper.STORAGE_KEY.ACCESS_TOKEN);
    localStorage.removeItem(StorageHelper.STORAGE_KEY.USER_INFORMATION);
    localStorage.removeItem(StorageHelper.STORAGE_KEY.LIST_ACTION_ACTIVE);
    localStorage.removeItem(StorageHelper.STORAGE_KEY.OLD_ACCESS_TOKEN);
    localStorage.removeItem(StorageHelper.STORAGE_KEY.APP_KEY);

    localStorage.removeItem(LocalStorageConfigKeys.global.layouts.currentThemeMode);

    sessionStorage.clear();
  }

  public static setAccessToken(token: string) {
    localStorage.setItem(StorageHelper.STORAGE_KEY.ACCESS_TOKEN, token);
  }
  public static getAccessToken() {
    return localStorage.getItem(StorageHelper.STORAGE_KEY.ACCESS_TOKEN) ?? '';
  }

  public static  saveOldAccessToken(token: string) {
    localStorage.setItem(StorageHelper.STORAGE_KEY.OLD_ACCESS_TOKEN, token);
  }

  public static getOldAccessToken() {
    return localStorage.getItem(StorageHelper.STORAGE_KEY.OLD_ACCESS_TOKEN) ?? '';
  }

  public static getUserInfo() {
    const info = localStorage.getItem(
      StorageHelper.STORAGE_KEY.USER_INFORMATION
    );
    if (info) {
      return JSON.parse(info);
    }
    return null;
  }

  public static setUserInfo(authInfo: any) {
    localStorage.setItem(
      StorageHelper.STORAGE_KEY.USER_INFORMATION,
      JSON.stringify(authInfo)
    );
  }

  public static storeRequireUpdateInfoToUseApp(info: any) {
    sessionStorage.setItem(
      StorageHelper.STORAGE_KEY.REQUIRE_UPDATE_MORE_INFO_AFTER_ENTER_APP,
      JSON.stringify(info)
    );
  }

  public static getRequireUpdateInfoToUseApp() {
    const info = sessionStorage.getItem(
      StorageHelper.STORAGE_KEY.REQUIRE_UPDATE_MORE_INFO_AFTER_ENTER_APP
    );
    if (info) {
      return JSON.parse(info);
    }
    return [];
  }

  public static getActivatedAction() {
    const info = localStorage.getItem(
      StorageHelper.STORAGE_KEY.LIST_ACTION_ACTIVE
    );
    if (info) {
      return JSON.parse(info);
    }
    return [];
  }

  public static getCurrentAuthEvent() {
    const info = localStorage.getItem(StorageHelper.STORAGE_KEY.AUTH_EVENT);
    if (info) {
      return JSON.parse(info);
    }
    return null;
  }
  public static setCurrentAuthEvent(event: IAuthEvent) {
    localStorage.setItem(
      StorageHelper.STORAGE_KEY.AUTH_EVENT,
      JSON.stringify(event)
    );
  }

  public static setAppKey(key: string) {
    localStorage.setItem(StorageHelper.STORAGE_KEY.APP_KEY, key);
  }

  public static getAppKey() {
    return localStorage.getItem(StorageHelper.STORAGE_KEY.APP_KEY);
  }

  public static setAccountFirstLoginHaveAVerifyLogic(bool: boolean) {
    sessionStorage.setItem(
      StorageHelper.STORAGE_KEY.HAVE_A_VERIFY_LOGIC,
      bool ? 'yes' : 'no'
    );
  }

  public static getAccountFirstLoginHaveAVerifyLogic() {
    return sessionStorage.getItem(
      StorageHelper.STORAGE_KEY.HAVE_A_VERIFY_LOGIC
    ) == 'yes'
      ? true
      : false;
  }

  public static removeAccountFirstLoginHaveAVerifyLogic() {
    sessionStorage.removeItem(StorageHelper.STORAGE_KEY.HAVE_A_VERIFY_LOGIC);
  }
}
